<template>
    <div>
        <div v-for="guess in guesses">{{guess}}</div>
    </div>
</template>

<script>
    import NameValue from "../../NameValue";
    import {mapGetters} from "vuex";

    export default {
        components: {NameValue},
        computed: {
            ...mapGetters(['comments']),
            guesses() {
                let res = [];
                let keywordGuess = [
                    {matches: ['my girlfriend', 'my gf'], result: 'Has a girlfriend'},
                    {matches: ['my boyfriend', 'my bf'], result: 'Has a boyfriend'},
                    {matches: ['my husband'], result: 'Has a husband'},
                    {matches: ['my wife'], result: 'Has a wife'},
                    {matches: ['my dog'], result: 'Has a dog'},
                    {matches: ['my cat'], result: 'Has a cat'},
                    {matches: ['my iphone'], result: 'Has an iPhone'},
                    {matches: ['my sister'], result: 'Has an sister'},
                    {matches: ['my brother'], result: 'Has a brother'},
                ];

                this.comments.map(d => d.data).forEach(d => {
                    keywordGuess.forEach(k => {
                        k.matches.forEach(m => {
                            if (d.body.toLowerCase().includes(m) && !res.includes(k.result))
                                res.push(k.result)
                        });
                    });
                });
                return res;
            }
        }
    }
</script>

<style scoped>

</style>
